// ════════════════════════════════════════════════════════════════
// USE AUTO LOCK — Inactivity timer that locks the vault
// ════════════════════════════════════════════════════════════════

import { useEffect } from 'react';
import { useVaultStore } from '../stores/vaultStore';

const DEFAULT_LOCK_MINUTES = 5;

export function useAutoLock(minutes: number = DEFAULT_LOCK_MINUTES): void {
  const isUnlocked = useVaultStore((s) => s.isUnlocked);
  const lockVault = useVaultStore((s) => s.lockVault);

  useEffect(() => {
    if (!isUnlocked) return;

    const timeoutMs = minutes * 60 * 1000;
    let timer: ReturnType<typeof setTimeout>;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(lockVault, timeoutMs);
    };

    // Track user activity events
    const events = ['mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'];
    events.forEach((e) =>
      document.addEventListener(e, resetTimer, { passive: true })
    );

    // Lock when the app goes to background
    const handleVisibilityChange = () => {
      if (document.hidden) {
        lockVault();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach((e) => document.removeEventListener(e, resetTimer));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isUnlocked, lockVault, minutes]);
}
